/* ==========================================================================
   Mega menu: de kaart onder zijn eigen menu-item

   De dropdown is een kaart (.mega-menu__grid) in een paneel dat Horizon over
   de volle breedte hangt. Dat paneel laten we staan, want Horizon opent en
   sluit het met een clip-path die op die breedte rekent (zie versie 8 in
   el-megamenu.css). Zonder dit script staat de kaart daarom altijd aan de
   paginamarge, ook als je op het vierde menu-item hovert.

   Dit script meet waar het menu-item staat en zet het verschil als
   --el-mm-offset op het <li>. el-megamenu.css schuift de kaart daarmee op:

     .menu-list__list-item:not([slot="overflow"]) .mega-menu__grid {
       margin-inline-start: var(--el-mm-offset, 0px);
     }

   Zonder script of zonder meting valt de variabele terug op 0px: dan staat de
   kaart zoals voorheen aan de paginamarge. Niets hangt van dit script af.

   ---------------------------------------------------------------------------
   Wat bewust zo is
   ---------------------------------------------------------------------------
   Gemeten bij hover en focus, niet bij het laden. Het header-menu verplaatst
   items naar "Meer" als het krap wordt, lettertypes laden later in, en
   Horizon tekent de header soms opnieuw. Een meting op het moment dat je het
   item aanraakt is altijd actueel, en kost niets. Bij het wijzigen van het
   venster wordt het open item opnieuw gemeten.

   De kaart begint onder de linkerrand van de menulink en blijft binnen
   dezelfde marges als de pagina. Past hij rechts niet meer, dan schuift hij
   zo ver terug als nodig is. Het hangt dus onder het item voor zover dat kan,
   en nooit buiten het scherm.

   Een kaart die de volle breedte nodig heeft (de variant met beeldtegels) en
   items in het "Meer"-paneel blijven op 0: die positioneert het thema zelf.

   Rechts-naar-links wordt meegenomen via de richting van de kaart zelf.
   ========================================================================== */

(() => {
  if (window.elMegamenuGeladen) return;
  window.elMegamenuGeladen = true;

  const RAND = 8; // minimale afstand van de kaart tot de schermrand, in px
  const ITEM = '.menu-list__list-item';
  const KAART = '.mega-menu__grid';

  /* Meet één menu-item en zet --el-mm-offset. Geeft niets terug. */
  function meet(item) {
    if (!(item instanceof HTMLElement)) return;

    const kaart = item.querySelector(KAART);
    if (!kaart) return;

    const zetten = (px) => {
      const waarde = `${Math.round(px)}px`;
      if (item.style.getPropertyValue('--el-mm-offset') !== waarde) {
        item.style.setProperty('--el-mm-offset', waarde);
      }
    };

    // Het "Meer"-paneel, verborgen items en de beeldvariant: niet verschuiven
    if (item.slot === 'overflow' || item.getAttribute('aria-hidden') === 'true' || kaart.querySelector('.mega-menu__content')) {
      zetten(0);
      return;
    }

    const link = item.querySelector('.menu-list__link');
    const paneel = kaart.closest('.mega-menu');
    if (!link || !paneel) return;

    const kaartRect = kaart.getBoundingClientRect();
    const linkRect = link.getBoundingClientRect();
    const paneelRect = paneel.getBoundingClientRect();

    // Een item dat nu niet getekend wordt (display: none) heeft niets te meten
    if (!kaartRect.width || !linkRect.width || !paneelRect.width) return;

    const stijl = getComputedStyle(kaart);
    const rtl = stijl.direction === 'rtl';

    /* De opschuiving die er nu op staat, zodat we de natuurlijke plek kennen
       (waar de kaart zonder opschuiving zou staan). */
    const huidig = parseFloat(stijl.marginInlineStart) || 0;

    /* De kaart mag iets voor de paginamarge komen als de tekst van het menu
       zelf daar begint (de header en de pagina hebben niet altijd precies
       dezelfde marge), maar nooit dichter dan RAND px bij de schermrand. */
    if (!rtl) {
      const natuurlijk = kaartRect.left - huidig;
      const marge = natuurlijk - paneelRect.left; // de paginamarge links
      const rechterGrens = paneelRect.right - marge; // dezelfde marge rechts
      const gewenst = linkRect.left - natuurlijk;
      const maximaal = rechterGrens - natuurlijk - kaartRect.width;
      const minimaal = Math.min(0, RAND - marge);
      zetten(Math.max(minimaal, Math.min(gewenst, maximaal)));
    } else {
      const natuurlijk = kaartRect.right + huidig;
      const marge = paneelRect.right - natuurlijk;
      const linkerGrens = paneelRect.left + marge;
      const gewenst = natuurlijk - linkRect.right;
      const maximaal = natuurlijk - linkerGrens - kaartRect.width;
      const minimaal = Math.min(0, RAND - marge);
      zetten(Math.max(minimaal, Math.min(gewenst, maximaal)));
    }
  }

  const itemVan = (doel) => (doel instanceof Element ? doel.closest(ITEM) : null);

  /* pointerover en niet pointerenter: dat bubbelt, dus één luisteraar op het
     document volstaat, ook als Horizon de header opnieuw tekent. Capture, zodat
     we klaar zijn voor het thema het item activeert. */
  document.addEventListener('pointerover', (event) => meet(itemVan(event.target)), true);
  document.addEventListener('focusin', (event) => meet(itemVan(event.target)), true);

  // Venster of lettertype verandert terwijl een dropdown open staat
  let wacht = 0;
  const opnieuw = () => {
    cancelAnimationFrame(wacht);
    wacht = requestAnimationFrame(() => {
      document.querySelectorAll(`${ITEM}:hover, ${ITEM}:focus-within`).forEach(meet);
    });
  };
  window.addEventListener('resize', opnieuw, { passive: true });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(opnieuw);
})();
